import { render, staticRenderFns } from "./TitleBarWithButton.vue?vue&type=template&id=b1b2cf30"
import script from "./TitleBarWithButton.vue?vue&type=script&lang=js"
export * from "./TitleBarWithButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports